import appConfig from "@/config/appConfig";
import { useGetByIdDashboardQuery } from "@/redux/api/dashboardApi";
import { Button, Form } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import { popFromHistory } from "@/redux/slices/dashboardV2.slice";
import DashboardBody from "./DashboardBody";
import TimePeriodFilter from "./TimePeriodFilter";

const DynamicDashboard = ({ id, isFullScreenActive }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { prevDashboardHistory } = useSelector((state) => state.dashboardV2) || {};

  const [tabId, setTabId] = useState("");
  const [formData, setFormData] = useState({ comparisonPeriods: [{ color: "red" }] });

  // rkt query
  const { data: dashboardData } = useGetByIdDashboardQuery({ id }, { skip: !id });
  const dashboard = dashboardData?.data || {};

  const [data, setData] = useState(() => (dashboardData?.data?._id === id ? dashboardData.data : {}));

  useEffect(() => {
    setData((prev) => (prev?._id === id ? prev : {}));
  }, [id]);

  useEffect(() => {
    if (dashboardData?.data) {
      let dData = dashboardData.data;
      const targetTabId = new URLSearchParams(location.search).get("tabId");
      if (dData?.hasTabs && dData?.tabs?.length > 0) {
        if (targetTabId) {
          const matchIdx = dData.tabs.findIndex((t) => t.tabId === targetTabId || t._id === targetTabId);
          if (matchIdx !== -1) {
            dData = {
              ...dData,
              tabs: dData.tabs.map((tab, idx) => ({
                ...tab,
                isSelected: idx === matchIdx,
              })),
            };
            setData(dData);
            return;
          }
        }
      }
      // ponytail: preserve user tab selection when tabId is cleaned from search params
      setData((prev) => (prev?._id === dData._id && prev?.tabs?.length > 0 ? prev : dData));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardData, location.search]);

  useEffect(() => {
    document.title = appConfig.name;
  }, []);

  const customSelectorProps = {
    form,
    gridData: dashboard?.hasTabs ? dashboard.tabs?.find((t) => t.isSelected)?.items : dashboard?.tabs?.[0]?.items,
    formData,
    setFormData,
    dashboard,
    tabId,
    data,
    setData,
  };

  return (
    <div>
      <div className="d-block d-sm-flex pb-3">{!isFullScreenActive && <TimePeriodFilter customSelectorProps={customSelectorProps} />}</div>
      <div className="az-content-body p-0 px-md-3">
        <div className="row row-sm mg-b-15 mg-sm-b-20">
          {/* redesign */}
          <DashboardBody
            {...{
              mode: "home",
              id,
              isFullScreenActive,
              setTabId,
              data,
              setData,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DynamicDashboard;

DynamicDashboard.propTypes = {
  id: PropTypes.string.isRequired,
  isFullScreenActive: PropTypes.bool,
};
